import { usePageTitle } from '../hooks/usePageTitle';

export default function Privacy() {
  usePageTitle("Privacy Policy — Chuck's Mojito Shack");

  return (
    <div className="container page-content py-5" style={{ maxWidth: '760px' }}>
      <h1 className="mb-1">Privacy Policy</h1>
      <p className="text-muted mb-4">
        <small>Last updated: March 2026 &mdash; or whenever Chuck remembered to update this</small>
      </p>

      <p>
        Welcome to Chuck's Mojito Shack. We take your privacy&hellip; into consideration.
        Occasionally. This policy explains what we collect, what we do with it, and why you should
        probably just relax and enjoy your mojito instead of reading this.
      </p>

      <h2 className="mt-4">What We Collect</h2>
      <p>
        When you use this site, we may collect information such as your name, email address, drink
        preferences, and the approximate number of mojitos you have consumed before arriving here.
        We also collect whatever your browser hands us without asking, which is frankly more than we
        expected.
      </p>

      <h2 className="mt-4">What We Do With It</h2>
      <p>
        Mostly nothing. Possibly something. Chuck has a spreadsheet somewhere. It may or may not be
        password-protected. It is almost certainly named{' '}
        <code>final_FINAL_v3_use_this_one.xlsx</code>.
      </p>
      <p>
        We do not sell your data to third parties. We do, however, occasionally mention you by first
        name at the bar when your order is ready, which is technically a disclosure.
      </p>

      <h2 className="mt-4">Cookies</h2>
      <p>
        This site uses cookies for authentication purposes. We do not use tracking cookies, ad
        cookies, or any of the weird cookies. Just the boring login kind. If your browser is set to
        reject all cookies, you will not be able to log in, and Chuck will take that personally.
      </p>

      <h2 className="mt-4">Third-Party Services</h2>
      <p>
        We use Microsoft Entra ID for authentication. Microsoft has their own privacy policy, which
        is significantly longer than this one and contains the phrase "legitimate interests"
        approximately 47 times. We encourage you to read it if you enjoy that sort of thing.
      </p>

      <h2 className="mt-4">Data Retention</h2>
      <p>
        We retain your data for as long as reasonably necessary, which we define as "until Chuck
        upgrades his laptop." Historical evidence suggests this is indefinite.
      </p>

      <h2 className="mt-4">Your Rights</h2>
      <p>
        Depending on where you live, you may have the right to access, correct, or delete your
        personal data. You may also have the right to a free mojito, but that one is not legally
        enforceable and varies by mood and inventory.
      </p>
      <p>
        To exercise your rights, email us at{' '}
        <a href="mailto:privacy@chucksmojitoshack.com">privacy&#64;chucksmojitoshack.com</a>.
        Response times may vary based on current bartending volume.
      </p>

      <h2 className="mt-4">Security</h2>
      <p>
        We implement reasonable security measures to protect your information. "Reasonable" is doing
        a lot of work in that sentence. We use HTTPS. The site requires login. Chuck changes the
        WiFi password every six months whether it needs it or not.
      </p>

      <h2 className="mt-4">Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. When we do, we will change the date at the top.
        We will not send you an email. You will have to notice on your own. We believe in you.
      </p>

      <h2 className="mt-4">Contact</h2>
      <p>
        Questions about privacy? Concerns about data? Just want to talk? Reach us at{' '}
        <a href="mailto:privacy@chucksmojitoshack.com">privacy&#64;chucksmojitoshack.com</a> or stop
        by the Shack in person. The second option is strongly preferred. We'll make you a drink.
      </p>

      <hr className="my-4" />
      <p className="text-muted">
        <small>
          Chuck's Mojito Shack is not a law firm. This policy does not constitute legal advice.
          Nothing on this site constitutes legal advice. If you need legal advice, hire a lawyer and
          then meet them here &mdash; first round is on us.
        </small>
      </p>
    </div>
  );
}
